import { render, staticRenderFns } from "./DashboardBtn.vue?vue&type=template&id=04b3e18b&scoped=true&"
import script from "./DashboardBtn.vue?vue&type=script&lang=js&"
export * from "./DashboardBtn.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBtn.vue?vue&type=style&index=0&id=04b3e18b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b3e18b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VCard,VCardText,VCol,VIcon,VResponsive})
